export const variables = {
    //API_URL: "https://localhost:44487/",
    API_URL: "https://npa.azurewebsites.net/",
    CURR_NBA_SEASON: 2024
}
     